export default __webpack_public_path__ + "static/media/chevron-left-hover.5fc2a448.svg";